import { __awaiter, __decorate, __extends, __generator } from "tslib";
import AvalonGTView from '@/utils/libs/BaseView';
import NavPanel from '@/components/common/NavPanel.vue';
import { Options } from 'vue-class-component';
import { PageService } from '@/views/copy/activity/import';
import { Toast } from 'vant';
var View = /** @class */ (function (_super) {
    __extends(View, _super);
    function View() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.riskList = [
            {
                title: '1、以进一步交友为由，索要财物',
                desc: '例如：不良分子以奔现见面、一夜情、见家长、结婚生子等理由，向用户索要红包转账或其他财物；',
            },
            {
                title: '2、利用低俗色情为由索要财物',
                desc: '例如：不良分子在文字、视频通话过程中，以低俗暴露、谈论性话题、模仿挑逗等行为，向用户索要红包转账或其他财物并承诺提供色情服务；',
            },
            {
                title: '3、编造虚假信息博取信任后索要财物',
                desc: '例如：不良分子以临时借钱、经济困难、做生意、伪造平台通知、刷单兼职等为由，向用户索要红包转账或其他财物；',
            },
            {
                title: '4、其他涉嫌违法获利行为',
                desc: '例如：不良分子引诱参与赌博、下载其他软件、推销理财产品等不法手段获取他人财产的不良目的行为；',
            },
        ];
        _this.cleanNetList = [];
        _this.topBgLoaded = false;
        // mock 名单数据（联调完成后可删除）
        _this.mockCleanNetList = [
            { ttno: '4332432', frozen_desc: '涉嫌诈骗', result: '永久封禁' },
            { ttno: '5821097', frozen_desc: '低俗色情', result: '永久封禁' },
            { ttno: '6109853', frozen_desc: '虚假信息', result: '限流处理' },
            { ttno: '7743261', frozen_desc: '诱导赌博', result: '永久封禁' },
            { ttno: '8890124', frozen_desc: '恶意骚扰', result: '封号7天' },
            { ttno: '9012587', frozen_desc: '线下交易', result: '永久封禁' },
        ];
        return _this;
    }
    Object.defineProperty(View.prototype, "topBgUrl", {
        get: function () {
            return this.awlGlobalConfig.getH5ImgUrl('activity/CleanNetAction/new_top_bg_huanxun.png');
        },
        enumerable: false,
        configurable: true
    });
    View.prototype.mounted = function () {
        var img = this.$refs.topBgRef;
        if (img === null || img === void 0 ? void 0 : img.complete) {
            this.topBgLoaded = true;
        }
    };
    View.prototype.onTopBgLoad = function () {
        this.topBgLoaded = true;
    };
    View.prototype.created = function () {
        if (this.awlGlobalState.urlInitParams.bannerId) {
            this.getActivity();
        }
        this.getCleanNetAction();
    };
    View.prototype.getCleanNetAction = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, list;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, PageService.getCleanNetAction()];
                    case 1:
                        data = _a.sent();
                        list = Array.isArray(data) ? data : [];
                        // mock：接口暂无数据时用假数据占位，方便调试样式
                        this.cleanNetList = list;
                        return [2 /*return*/];
                }
            });
        });
    };
    // 2022/2/20 10:41 获取活动状态
    View.prototype.getActivity = function () {
        PageService.getActivityStatus({
            bannerId: this.awlGlobalState.urlInitParams.bannerId,
        }).then(function (data) {
            if (Number(data.activityStatus) != 1 && data.text) {
                Toast(data.text);
            }
        });
    };
    View = __decorate([
        Options({
            name: 'IndexCleanNetAction',
            components: { NavPanel: NavPanel },
        })
    ], View);
    return View;
}(AvalonGTView.BaseView));
export default View;
